module.exports = __webpack_public_path__ + "static/media/dutch.d770b847.svg";